<template>
    <div>
        <nav-breadcrumb :menu="[{label: partnerId ? '编辑合作方' : '新增合作方'}]"/>

        <el-row>
            <el-col>
                <panel label="基本信息">
                    <el-form :model="partnerForm" :rules="partnerFormmRules" ref="partnerForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="12" v-if="partnerForm.p__partnerCode==null">
                                <el-form-item label="合作方编号：" style="width: 60%">
                                    <el-input value="待生成" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="partnerForm.p__partnerCode!=null">
                                <el-form-item label="合作方编号：" style="width: 60%">
                                    <el-input v-model="partnerForm.p__partnerCode" disabled></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="合作方名称：" prop="p__partnerName" style="width: 60%" :rules="{required: true, message: '合作方名称不能为空'}">
                                    <el-input v-model="partnerForm.p__partnerName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="合作方类型：" prop="p__partnerType" :rules="{required: true, message: '合作方类型不能为空'}" style="width: 60%">
                                    <el-select placeholder="请选择合作方类型" v-model.trim="partnerForm.p__partnerType" >
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in partnerOptions" :key="idx"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="负责人：" prop="p__contactPerson" style="width: 60%">
                                    <el-input v-model="partnerForm.p__contactPerson"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="状态：" prop="p__partnerStatus" :rules="{required: true, message: '状态不能为空'}">
                                    <el-select placeholder="请选择状态" v-model.trim="partnerForm.p__partnerStatus" >
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in disabledOptions" :key="idx"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系方式：" prop="p__contactNo" style="width: 60%">
                                    <el-input v-model="partnerForm.p__contactNo"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <panel label="开票信息">

                                <el-row :gutter="10" class="bg-purple xamhtrpg">
                                    <el-col :span="12">
                                        <el-form-item label="公司名称：" prop="t__companyName" style="width: 60%" :rules="{required: true, message: '公司名称不能为空'}">
                                            <el-input v-model="partnerForm.t__companyName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="税号：" prop="t__taxNo" style="width: 60%" :rules="{required: true, message: '税号不能为空'}">
                                            <el-input v-model="partnerForm.t__taxNo"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="单位地址：" prop="t__address" style="width: 60%">
                                            <el-input v-model="partnerForm.t__address"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="开户银行：" prop="t__bankName" style="width: 60%">
                                            <el-input v-model="partnerForm.t__bankName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="电话：" prop="t__telephone" style="width: 60%">
                                            <el-input v-model="partnerForm.t__telephone"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="银行账户：" prop="t__accountNo" style="width: 60%">
                                            <el-input v-model="partnerForm.t__accountNo"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                        </panel>
                    </el-form>
                </panel>

            </el-col>
        </el-row>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('partnerForm')">确认提交</el-button>
            <el-button @click="$router.back()">取消</el-button>
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    export default {
        name: "BusinessPartnerAdd",
        data(){
            return {
                partnerId: this.$route.query['partnerId']||'',
                partnerForm:{
                    p__partnerStatus: 'N'
                },

                partnerOptions:[
                    {
                        label:'助贷机构',
                        value:'A'
                    },
                    {
                        label:'资管公司',
                        value:'B'
                    },
                    {
                        label:'技术服务',
                        value:'C'
                    }
                ],
                disabledOptions:[
                    {
                        label:'启用',
                        value:'N'
                    },
                    {
                        label:'禁用',
                        value:'Y'
                    },
                ],
                partnerFormmRules: {},
            }
        },
        mounted() {
            if(this.partnerId){
                this.getData()
            }
        },
        methods:{
            getData:function(){
                xhr.getBusinessPartner({
                        'p.partnerId': this.partnerId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.partnerForm = res.data.data
                            }
                        }catch (e) {

                        }
                    })
            },
            onSubmit: function (formName) {
                let partnerForm = this.partnerForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        partnerForm.p__checked = true
                        xhr.updateBusinessPartner(partnerForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.$router.push({
                                        name: 'BusinessPartnerListView'
                                    })
                                }
                            } catch (error) {
                                this.$message.error(error.msgs[0].text)
                            }
                        })
                    }
                })

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/BusinessPartnerAdd.vue